export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      files: [
        {
          fileId: 43,
          fileUuid: "files043",
          fileName: "txt01.txt",
          fileUri: "/txt/txt01.txt",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 42,
          fileUuid: "files042",
          fileName: "txt02.txt",
          fileUri: "/txt/txt02.txt",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            },
            {
              serviceUuid: "services004",
              serviceName: "△△地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 41,
          fileUuid: "files041",
          fileName: "txt03.txt",
          fileUri: "/txt/txt03.txt",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services001",
              serviceName: "アイラ地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 33,
          fileUuid: "files033",
          fileName: "pdf01.pdf",
          fileUri: "/pdf/pdf01.pdf",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 32,
          fileUuid: "files032",
          fileName: "pdf02.pdf",
          fileUri: "/pdf/pdf02.pdf",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            },
            {
              serviceUuid: "services004",
              serviceName: "△△地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 31,
          fileUuid: "files031",
          fileName: "pdf03.pdf",
          fileUri: "/pdf/pdf03.pdf",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services001",
              serviceName: "アイラ地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 23,
          fileUuid: "files023",
          fileName: "sound01.mp3",
          fileUri: "/mp3/sound01.mp3",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 22,
          fileUuid: "files022",
          fileName: "sound02.mp3",
          fileUri: "/mp3/sound02.mp3",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 21,
          fileUuid: "files021",
          fileName: "sound03.mp3",
          fileUri: "/mp3/sound03.mp3",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services001",
              serviceName: "アイラ地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 13,
          fileUuid: "files013",
          fileName: "video01.mp3",
          fileUri: "/mp4/video01.mp3",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 12,
          fileUuid: "files012",
          fileName: "video02.mp3",
          fileUri: "/mp4/video02.mp3",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            },
            {
              serviceUuid: "services004",
              serviceName: "△△地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 11,
          fileUuid: "files011",
          fileName: "video03.mp3",
          fileUri: "/mp4/video03.mp3",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services001",
              serviceName: "アイラ地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 3,
          fileUuid: "files003",
          fileName: "bg_cafe.jpg",
          fileUri: "/images/img01.png",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 2,
          fileUuid: "files002",
          fileName: "sky.jpg",
          fileUri: "/images/img01.png",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            },
            {
              serviceUuid: "services004",
              serviceName: "△△地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 1,
          fileUuid: "files001",
          fileName: "ocean.jpg",
          fileUri: "/images/img01.png",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services001",
              serviceName: "アイラ地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        }
      ]
    }
  }
}